import { render, staticRenderFns } from "./DriverHoursStatistics.vue?vue&type=template&id=bb42558e&scoped=true&"
import script from "./DriverHoursStatistics.vue?vue&type=script&lang=js&"
export * from "./DriverHoursStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DriverHoursStatistics.vue?vue&type=style&index=0&id=bb42558e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb42558e",
  null
  
)

export default component.exports